package domain.usecase

import domain.model.PullRequest
import domain.repository.GitHubRepository

class GetPullRequestsUseCase(
    private val repository: GitHubRepository
) {
    suspend operator fun invoke(): List<PullRequest> {
        return repository.getPullRequests()
    }
}
